export const GRANT_ACCESS_BY_ID = `
mutation grantCompanyAccess($companyIds: [Float!]!) {
  grantCompanyAccess(companyIds:$companyIds){
  code
  message
  }
}
`;

export const REMOVE_COMP_ACCESS_BY_COMP = `
mutation removeCompanyAccessByCompany($individualId: Float!, $confirmPendingMU4: Boolean) {
  removeCompanyAccessByCompany(individualId:$individualId, confirmPendingMU4:$confirmPendingMU4){
  code
  message
  result
  }
}
`;

export const REMOVE_COMP_ACCESS_BY_IND = `
mutation removeCompanyAccessByIndividual($companyId: Float!, $confirmMU2Association: Boolean, $confirmPendingMU4: Boolean) {
  removeCompanyAccessByIndividual(companyId:$companyId, confirmMU2Association:$confirmMU2Association, confirmPendingMU4:$confirmPendingMU4){
  code
  message
  result
  mu2Relations {
            branchOfficeId
            companyName
            industry
            startDate
            type
        }
  }
}
`;

export const REQUEST_COMPANY_ACCESS = `
mutation RequestCompanyAccessforIndividual($subjectId: Float!) {
    requestCompanyAccessforIndividual(subjectId: $subjectId) {
        workItemId
        code
        message
    }
}
`;

export const HANDLE_REQUEST_COMPANY_ACCESS = `
mutation HandleCompanyAccessRequest($workItemKey: String!, $action: String!, $companyId: Float!) {
    handleCompanyAccessRequest(
        companyAccessRequestInput: { action: $action, companyId: $companyId, workItemKey: $workItemKey }
    ) {
        code
        message
    }
}
`;

export const CREATE_COMPANY_RELATIONSHIP = `
mutation CreateRelationship($individualId: Float!, $isEmployee: Boolean!, $relationshipStartDate: String!, $locationIds: [Float!]!, $remoteWorkType: RemoteWorkEnum!, $remoteLocation: RemoteLocationInput, $businessEmail: String!, $businessPhone: String!, $businessPhoneExtension: String, $position: String!) {
  createRelationship(
        createCompanyRelationRequest  :
    {
        individualId : $individualId
        isEmployee : $isEmployee
        relationshipStartDate : $relationshipStartDate
        locationIds: $locationIds
        remoteWorkType: $remoteWorkType
        remoteLocation: $remoteLocation
        businessEmail : $businessEmail
        businessPhone : $businessPhone
        businessPhoneExtension : $businessPhoneExtension
        position : $position
    }){
        code
        message
    }
}`;

export const UPDATE_ENDED_COMPANY_RELATIONSHIP = `
mutation UpdateEndedCompanyRelationship($relationshipId: Float!, $relationshipEndDate: String!, $endingReason: EndingReason!, $deceasedDate: String, $endingExplanation: String, $editEndedRelationshipReason: String!) {
  updateEndedCompanyRelationship(
        relationshipData:
    {
        relationshipId: $relationshipId
        relationshipEndDate: $relationshipEndDate
        endingReason: $endingReason
        deceasedDate: $deceasedDate
        endingExplanation: $endingExplanation
        editEndedRelationshipReason: $editEndedRelationshipReason
    }){
        code
        message
    }
}`;

export const END_COMPANY_RELATIONSHIP = `
mutation EndCompanyRelationship($relationshipId: Float!, $relationshipEndDate: String!, $endingReason: EndingReason, $deceasedDate: String, $endingExplanation: String) {
  endCompanyRelationship(
        relationshipData:
    {
        relationshipId: $relationshipId
        relationshipEndDate: $relationshipEndDate
        endingReason: $endingReason
        deceasedDate: $deceasedDate
        endingExplanation: $endingExplanation
    }){
        code
        message
    }
}`;

export const EDIT_COMPANY_RELATIONSHIP_DETAILS = `
mutation UpdateActiveCompanyRelationship($relationshipId: Float!, $isEmployee: Boolean!, $relationshipStartDate: String!, $workerClassificationStartDate: String!, $remoteWorkType: RemoteWorkEnum!, $remoteLocation: RemoteLocationInput, $businessEmail: String!, $businessPhone: String!, $businessPhoneExtension: String, $position: String!) {
  updateActiveCompanyRelationship(
        relationshipData :
    {
        relationshipId : $relationshipId
        isEmployee : $isEmployee
        relationshipStartDate : $relationshipStartDate
        workerClassificationStartDate: $workerClassificationStartDate
        remoteWorkType: $remoteWorkType
        remoteLocation: $remoteLocation
        businessEmail : $businessEmail
        businessPhone : $businessPhone
        businessPhoneExtension : $businessPhoneExtension
        position : $position
    }){
        code
        message
    }
}
`;

export const CANCEL_REQUEST_COMPANY_ACCESS = `
mutation CancelPendingCompanyAccessRequest($subjectId: Float!, $workItemKey: String!) {
    cancelPendingCompanyAccessRequest(
        cancelPendingCompanyAccessInput: { subjectId: $subjectId, workItemKey: $workItemKey }
    ) {
        code
        message
    }
}
`;

export const ADD_RELATIONSHIPS_LOCATIONS = `
mutation AddRelationshipLocations($locationBeginDate: String!, $relationshipId: Float!, $locationIds: [Float!]!) {
  addRelationshipLocations(
        locationData :
    {
        locationBeginDate: $locationBeginDate
        relationshipId : $relationshipId
        locationIds: $locationIds
    }){
        code
        message
    }
}
`;

export const UPDATE_RELATIONSHIPS_LOCATIONS = `
mutation UpdateRelationshipLocation($locationBeginDate: String!, $relationshipId: Float!, $locationId: Float!) {
  updateRelationshipLocation(
        locationData :
    {
        locationBeginDate: $locationBeginDate
        relationshipId : $relationshipId
        locationId: $locationId
    }){
        code
        message
    }
}
`;

export const REMOVE_RELATIONSHIPS_LOCATIONS = `
mutation RemoveRelationshipLocationInput($locationEndDate: String!, $relationshipId: Float!, $locationId: Float!) {
  removeRelationshipLocation(
        locationData :
    {
        locationEndDate: $locationEndDate
        relationshipId : $relationshipId
        locationId: $locationId
    }){
        code
        message
    }
}
`;

export const REMOVE_SPONSORSHIP = `
mutation RemoveSponsorship($sponsorshipId: Float!) {
    removeSponsorship(
        input:
    {
        sponsorshipId: $sponsorshipId
    }) {
        code
        message
    }
}`;

export const CREATE_SPONSORSHIP = `
mutation CreateSponsorship($companyRelationshipId: Float!, $individualId: Float!, $licenses : [LicenseSponsorship!]!) {
    createSponsorship(
        sponsorshipData :
    {
        companyRelationshipId: $companyRelationshipId
        individualId: $individualId
        licenses: $licenses

    }){
        code
        message
        isPaymentRequired
    }
}
`;

export const UPDATE_IR_ASSIGNEE = `
mutation UpdateIRAssignee($input: UpdateIRAssigneeInput!) {
    updateIRAssignee(input: $input) {
        code
        message
    }
}
`;

export const UPDATE_SYSTEM_TASK_ASSIGNEE = `
mutation UpdateSystemTaskAssignee($input: UpdateSystemTaskAssigneeInput!) {
    updateSystemTaskAssignee(input: $input) {
        code
        message
    }
}
`;

export const CREATE_MU1_FILING = `
mutation createMU1Filing {
    createMU1Filing {
          decafId
    }
}
`;
